import { IconProps } from "models"
import { ICON_DEFAULT_SIZE } from "utils/constants"

const UserIcon: React.FC<IconProps> = ({
	className = "",
	style = null,
	color = "currentColor",
	size = ICON_DEFAULT_SIZE,
}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="-26 0 437 437.333"
			className={className}
			style={style}
			aria-hidden="true"
		>
			<path
				fill={color}
				stroke={color}
				d="M192.168 213.332c-58.8 0-106.668-47.867-106.668-106.664C85.5 47.868 133.367 0 192.168 0c58.797 0 106.664 47.867 106.664 106.668 0 58.797-47.867 106.664-106.664 106.664zm0-192c-47.066 0-85.336 38.27-85.336 85.336 0 47.066 38.27 85.332 85.336 85.332 47.066 0 85.332-38.266 85.332-85.332 0-47.066-38.266-85.336-85.332-85.336zM384.168 437.332h-384v-10.664c0-105.867 86.133-192 192-192s192 86.133 192 192zM21.898 416h340.668c-5.464-89.2-79.867-160-170.398-160-90.535 0-164.8 70.8-170.27 160zm0 0"
			/>
		</svg>
	)
}

export default UserIcon
